import { render, staticRenderFns } from "./NewFreightChargesModal.vue?vue&type=template&id=60cb1332"
import script from "./NewFreightChargesModal.vue?vue&type=script&lang=js"
export * from "./NewFreightChargesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports